import React, { useState, useEffect} from 'react';
import ImageButton from './imageButton';

const Pause = ({channel, server_host, uid, username, roomId, is_coaching_room=false, is_owner=false, is_coach=false}) => {

  const [isFeedbackRunning, setIsFeedbackRunning] = useState(false);
  const [isRipRunning, setIsRipRunning] = useState(false);
  const [isPauseRunning, setIsPauseRunning] = useState(false);
  const [pauseDuration, setPauseDuration] = useState(0)

  // to begin with, restitution time is 1/4 of introspection time
    
  
  useEffect(() => {
    channel.on('pause status', status => {
      if (roomId === status['room']) {
        setIsPauseRunning((status['duration'] > 0))
        const is_master = status['originator'] === uid
        if (! is_master) {
          setPauseDuration(status['duration'])
        }
      }
    });
    channel.on('feedback status', status => {
        if (roomId === status['room']) {
          setIsFeedbackRunning((status['duration'] > 0))
        }
    });
    channel.on('rip status', status => {
        if (roomId === status['room']) {
          setIsRipRunning((status['duration'] > 0))
        }
    })
  }, [pauseDuration, isFeedbackRunning, isRipRunning, channel, roomId, uid]);

    useEffect(() => {
        let interval;
    
        if (isPauseRunning) {
          interval = setInterval(() => {
            const nduration = pauseDuration - 1000
            setPauseDuration(nduration);
            if (nduration <= 0) {
              setIsPauseRunning(false)
            }
            channel.emit('pause running', 
              {
                'room' : roomId, 
                'duration' : nduration, 
                'originator' : uid,
                'username' : username
              })
          }, 1000);
        }
        return () => clearInterval(interval);
      
  }, [isPauseRunning, roomId, pauseDuration, channel, uid, username]);
    
      const startTimer = () => {
        if (pauseDuration < 300000) {
          alert("Le temps minimal de pause est de 5 minutes")
          return
        }
        setIsPauseRunning(true);
        channel.emit('pause running', 
          {
            'room' : roomId, 
            'duration' : pauseDuration, 
            'originator' : uid,
            'username' : username,
          })
      };
    
      const addTimer = () => {
        setPauseDuration(pauseDuration + 60000);
      };

      const addTimer10 = () => {
        setPauseDuration(pauseDuration + 600000);
      };
    
      const subTimer = () => {
        const d = pauseDuration - 60000; 
        if (d <= 0) {
          setIsPauseRunning(false)
        }
        setPauseDuration(Math.max(0, d))
      };

      const subTimer10 = () => {
        const d = pauseDuration - 600000; 
        if (d <= 0) {
          setIsPauseRunning(false)
        }
        setPauseDuration(Math.max(0, d))
      };
    
      const stopTimer = () => {
        setIsPauseRunning(false);
        setPauseDuration(0)

      };
    
      const resetTimer = () => {
        setPauseDuration(300000);
      };
    

    const rtime = pauseDuration / 1000

    let protocol = process.env.REACT_APP_PROTOCOL
    if (protocol === undefined){
      protocol = "http"
    }


    if (! isRipRunning && ! isFeedbackRunning && rtime > 0){
        const minutes = Math.floor(rtime  / 60);
        const seconds = rtime % 60;
    
        return (
            <div className='pause' title='Temps de pause' >
              <div>
                {
                pauseDuration > 59000 && is_coach && is_owner && !isFeedbackRunning ? (
                <ImageButton
                    url={`${protocol}://${server_host}:3050/images/play-circle.svg`} size='small' 
                    onClick={startTimer} title="Pause !" color='lightgreen'/>
                ) : (' ')}
                { is_coach && is_owner ? (
                    <ImageButton
                    url={`${protocol}://${server_host}:3050/images/plus-circle.svg`}  title="+ 10'" size='small' 
                onClick={addTimer10} />) : ( ' ') }
                { is_coach && is_owner ? (
                  <ImageButton
                    url={`${protocol}://${server_host}:3050/images/plus.svg`}  title="+ 1'" size='small' 
                 onClick={addTimer}/> ) : (' ')}
                 { is_coach && is_owner ? (
                  <ImageButton
                    url={`${protocol}://${server_host}:3050/images/minus.svg`}  title="- 1'" size='small' 
                  onClick={subTimer}/> ) : (' ')}
                  { is_coach && is_owner ? (
                    <ImageButton
                    url={`${protocol}://${server_host}:3050/images/minus-circle.svg`} size='small'  title="- 10' ou annuler" 
                   onClick={subTimer10}/> ) : (' ')}
            </div>
            <span className='pauseValue'>
            Pause { pauseDuration > 0 ? (
                  minutes.toString().padStart(2, '0')) : (' ')}:
            { pauseDuration > 0 ? (
                  seconds.toString().padStart(2, '0')) : (' ')}</span>
          </div>
        )
    } else {
        return (
            <div className="pause" title="pause">
                { is_coach && is_owner && is_coaching_room && !isRipRunning && ! isFeedbackRunning ? (
                <ImageButton title="La pause !!!" color='#dfd046' size='small' 
                    url={`${protocol}://${server_host}:3050/images/coffee.svg`}
                onClick={() => resetTimer(180000)}/>
                ) : ' ' }
            </div>
        )
    }
}

export default Pause;